import { styled } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import { Typography } from '@components/Typography';

const AUDIENCE_LABEL_COLOR = {
    Promoter: {
        bg: 'rgba(11, 141, 0, 0.35)',
        bgLight: 'rgba(11, 141, 0, 0.15)',
        color: 'var(--text-primary)',
    },
    Neutral: {
        bg: 'rgba(255, 135, 0, 0.35)',
        bgLight: 'rgba(255, 135, 0, 0.15)',
        color: 'var(--text-primary)',
    },
    Detractor: {
        bg: 'rgba(176, 0, 32, 0.35)',
        bgLight: 'rgba(176, 0, 32, 0.15)',
        color: 'var(--text-primary)',
    },
};

export const LabelPlain = styled(Typography, {
    shouldForwardProp: prop => prop !== 'type' && prop !== 'size',
})(({ type, size }) => ({
    backgroundColor: AUDIENCE_LABEL_COLOR[type]?.bg || 'rgba(188, 201, 206, 1)',
    borderRadius: 8,
    color: AUDIENCE_LABEL_COLOR[type]?.color || 'var(--text-primary)',
    padding: size === 'small' ? '3px 6px' : '5px 8px',
    height: size === 'small' ? 20 : 24,
    display: 'inline-block',
    whiteSpace: 'nowrap',
    '&:not(:last-child)': {
        marginRight: 4,
    },
}));

export const LabelChip = styled(Chip, {
    shouldForwardProp: prop => prop !== 'type' && prop !== 'isPartlyAssigned' && prop !== 'disabled',
})(({ type, isPartlyAssigned, disabled }) => ({
    backgroundColor:
        !isPartlyAssigned && !disabled
            ? AUDIENCE_LABEL_COLOR[type]?.bg || 'rgba(188, 201, 206, 1)'
            : AUDIENCE_LABEL_COLOR[type]?.bgLight || 'rgba(228, 234, 235, 1)',
    borderRadius: 8,
    color: AUDIENCE_LABEL_COLOR[type]?.color || 'var(--text-primary)',
    padding: '3px 6px',
    height: 20,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    opacity: '1 !important',
    '&:hover': {
        backgroundColor:
            !isPartlyAssigned && !disabled
                ? AUDIENCE_LABEL_COLOR[type]?.bg || 'rgba(188, 201, 206, 1)'
                : AUDIENCE_LABEL_COLOR[type]?.bgLight || 'rgba(228, 234, 235, 1)',
        color: AUDIENCE_LABEL_COLOR[type]?.color || 'var(--text-primary)',
    },
    '& .MuiChip-label': {
        padding: 0,
        textOverflow: 'initial',
        overflow: 'visible',
        height: 20,
        display: 'flex',
        alignItems: 'center',
    },
    '& .MuiChip-deleteIcon': {
        width: 13,
        height: 13,
        color: 'var(--text-secondary)',
        margin: 0,
    },
}));
